import React, { useEffect } from 'react';

import FormField from '../../components/FormField';
import Loader from '../../components/Loader';
import useCompanyAdmin from '../../hooks/useCompanyAdmin';

const NewNature = ({ data, setData, onSubmit, loading }) => {
  const isUpdate = !!data?._id;
  const { companyAdmins, fetchAdmins } = useCompanyAdmin()
  const fields = [
    {
      label: 'Name',
      value: data.name,
      setValue: (value) => setData({ ...data, name: value }),
      placeholder: 'Name',
      type: 'text',
      className: 'mb-2',
    },
    {
      label: 'Email',
      value: data.email,
      setValue: (value) => setData({ ...data, email: value }),
      placeholder: 'Email',
      type: 'email',
      className: 'mb-2',
    },
    {
      label: 'Admin',
      options: companyAdmins,
      setValue: (value) => setData({ ...data, adminID: value }),
      placeholder: 'Select Admin',
      value: data?.adminID?._id || data?.adminID ,
      type: 'dropdown',
      className: 'mb-2',
    },
    {
      label: data.status ? 'Active' : 'InActive',
      value: data.status,
      setValue: (value) => setData({ ...data, status: value }),
      placeholder: 'Status',
      type: 'boolean',
      className: 'mb-2',
    },
  ]
  useEffect(() => {
    fetchAdmins()
  }, [])

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">{isUpdate ? 'Update' : 'New'} Admin</h5>
        {
          fields.map((item, index) => (
            <FormField item={item} key={index} />
          ))
        }
        <button className='btn btn-primary w-100 mt-3' onClick={onSubmit}>
          <Loader loading={loading} color={'white'}>
            {isUpdate ? 'Update' : 'Add'}
          </Loader>
        </button>
      </div>
    </div>
  )
}

export default NewNature